var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoaderOverlay',{attrs:{"loading":_vm.loading}},[_c('IssueForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }